//#region src/util/ref_properties.ts
const refProperties = [
	"type",
	"source",
	"source-layer",
	"minzoom",
	"maxzoom",
	"filter",
	"layout"
];
//#endregion
export { refProperties };

//# sourceMappingURL=ref_properties.mjs.map